import React from 'react'
import { ProgressSpinner } from 'primereact/progressspinner'

export const PortalSessionLoader = (): React.ReactElement => (
    <div
        className="flex align-items-center justify-content-center"
        style={{ minHeight: '50vh' }}
        data-testid="portal-session-loader"
    >
        <ProgressSpinner />
    </div>
)
